// import addIngredients from '../components/monitorCy/addIngredients.vue'
// import addKitchenJk from '../components/monitorCy/addKitchenJk.vue'
// import addRecipes from '../components/monitorCy/addRecipes.vue'
// import ingredientsList from '../components/monitorCy/ingredientsList.vue'
// import kitchenJkList from '../components/monitorCy/kitchenJkList.vue'
// import recipesList from '../components/monitorCy/recipesList.vue'
// import viewIngredients from '../components/monitorCy/viewIngredients.vue'
// import viewKitchenJk from '../components/monitorCy/viewKitchenJk.vue'
// import viewRecipes from '../components/monitorCy/viewRecipes.vue'

export default [
    {
        path: 'monitorCy/addIngredients',
        component: resolve => require(['@/components/monitorCy/addIngredients'],resolve),
        name:"AddIngredients",
        meta:{
            id:'705',
            node:'monitorCy',
            url:'addIngredients',
        }
    },
    {
        path: 'monitorCy/addKitchenJk',
        component: resolve => require(['@/components/monitorCy/addKitchenJk'],resolve),
        name:"AddKitchenJk",
        meta:{
            id:'699',
            node:'monitorCy',
            url:'addKitchenJk',
        }
    },
    {
        path: 'monitorCy/addRecipes',
        component: resolve => require(['@/components/monitorCy/addRecipes'],resolve),
        name:"AddRecipes",
        meta:{
            id:'702',
            node:'monitorCy',
            url:'addRecipes',
        }
    },
    {
        path: 'monitorCy/ingredientsList',
        component: resolve => require(['@/components/monitorCy/ingredientsList'],resolve),
        name:"IngredientsList",
        meta:{
            id:'704',
            node:'monitorCy',
            url:'ingredientsList',
        }
    },
    {
        path: 'monitorCy/kitchenJkList',
        component: resolve => require(['@/components/monitorCy/kitchenJkList'],resolve),
        name:"KitchenJkList",
        meta:{
            id:'698',
            node:'monitorCy',
            url:'kitchenJkList',
        }
    },
    {
        path: 'monitorCy/recipesList',
        component: resolve => require(['@/components/monitorCy/recipesList'],resolve),
        name:"RecipesList",
        meta:{
            id:'701',
            node:'monitorCy',
            url:'recipesList',
        }
    },
    {
        path: 'monitorCy/viewIngredients',
        component: resolve => require(['@/components/monitorCy/viewIngredients'],resolve),
        name:"ViewIngredients",
        meta:{
            id:'706',
            node:'monitorCy',
            url:'viewIngredients',
        }
    },
    {
        path: 'monitorCy/viewKitchenJk',
        component: resolve => require(['@/components/monitorCy/viewKitchenJk'],resolve),
        name:"ViewKitchenJk",
        meta:{
            id:'700',
            node:'monitorCy',
            url:'viewKitchenJk',
        }
    },
    {
        path: 'monitorCy/viewRecipes',
        component: resolve => require(['@/components/monitorCy/viewRecipes'],resolve),
        name:"ViewRecipes",
        meta:{
            id:'703',
            node:'monitorCy',
            url:'viewRecipes',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/monitorCy.js